import { sleep } from '@last/core'

import images from '@/images'

import type { TicketElement } from '../TicketElement'

export class Logo implements TicketElement {
  image: string
  ratio: number
  imageNode?: HTMLImageElement | null
  imageHeight?: number

  constructor(image: string, { ratio }: { ratio?: number } = {}) {
    this.image = image
    this.ratio = ratio || 1
  }

  async loadImage(width: number): Promise<number> {
    this.imageNode = await Promise.race([
      images.getImage(this.image),
      sleep(2_000).then(() => null)
    ])

    if (this.imageNode) {
      this.imageHeight = (this.imageNode.height / this.imageNode.width) * width * this.ratio
    } else {
      this.imageHeight = 0
    }

    return this.imageHeight
  }

  async height(ctx: CanvasRenderingContext2D, width: number): Promise<number> {
    if (!this.image || this.imageHeight === 0) return 0
    if (this.imageHeight) return this.imageHeight
    return await this.loadImage(width)
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    if (!this.imageHeight) return
    const ratio = this.ratio
    const height = this.imageHeight
    ctx.drawImage(
      this.imageNode as HTMLImageElement,
      width * 0.5 * (1 - ratio),
      top,
      width * ratio,
      height
    )
  }
}
